import { useTranslation } from "react-i18next";
import { formatAmount, printPaginationFooter } from "./helper";
import { statisticsFormatDate } from "./../../utils/helper";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "../primitives";

const CbansTable = (props) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.no")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.fileDate")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.completionDateTime")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.totalTransactions")}
            </TableCell>
            <TableCell align="right">
              {t("erps.statisticsEnquiry.page.label.totalPayments")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.fileMedium")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.auditNumber")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.pageData.map((row) => (
            <TableRow key={row.id}>
              <TableCell align="left">{row?.id}</TableCell>
              <TableCell align="left">
                {statisticsFormatDate(row?.fileDate)}
              </TableCell>
              <TableCell align="left">
                {statisticsFormatDate(row?.complitionDateTime)}
              </TableCell>
              <TableCell align="left">{row?.totalTransactions}</TableCell>
              <TableCell align="right">
                {formatAmount(row?.totalPayments)}
              </TableCell>
              <TableCell align="left">{row?.fileMedium}</TableCell>
              <TableCell align="left">{row?.auditNumber}</TableCell>
            </TableRow>
          ))}
          {props.initialDataLength > 100 && (
            <TableRow key="paginate-footer">
              <TableCell colSpan={7} align="right">
                {printPaginationFooter(
                  props.rowPerPage,
                  props.pageNumber,
                  props.initialDataLength
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CbansTable;
